"use client"

import { useEffect } from "react"
import { useRouter } from "next/navigation"

export default function FrameClientRedirect({
  slicerId,
  productId
}: {
  slicerId: string
  productId: string
}) {
  const router = useRouter()

  // TODO: Redirect to ocs if product is from ocs

  useEffect(() => {
    const url = new URL(window.location.href)
    let ref = url.searchParams.get("ref")
    let onsite = url.searchParams.get("onsite")

    router.push(
      process.env.NEXT_PUBLIC_SHOP_APP_URL +
        `/store/${slicerId}` +
        (onsite ? `/onsite` : "") +
        `?productId=${productId}` +
        (ref ? `&ref=${ref}` : "")
    )
  }, [slicerId, router])

  return <div></div>
}
